import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { environment } from './environments/environment';
import * as Highcharts from 'highcharts';
import DataTable from 'datatables.net';

import 'datatables.net-bs5';
DataTable.ext.classes.search.input = 'form-control';
DataTable.ext.classes.length.select = 'form-select';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);


if (environment.production) {
  enableProdMode();
  window.console.log = function (): void { };
  window.console.table = function (): void { };
  window.console.debug = function (): void { };
  window.console.warn = function (): void { };
  window.console.info = function (): void { };
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    shortWeekdays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    loading: 'Cargando...',
    noData: 'Sin datos para mostrar',
    resetZoom: 'Restablecer zoom',
    resetZoomTitle: 'Restablecer zoom nivel 1:1'
  }
} as any);
